
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { FormSubmissionValidationError, FormValue } from 'client-website-ts-library/types/Forms';
import { DropdownField, IFormField } from 'client-website-ts-library/types/Forms/FieldTypes';

import ErrorList from '../ErrorList.vue';

@Component({
  components: { ErrorList },
})
export default class FormRadioButtonField extends Vue implements IFormField {
  @Prop()
  private readonly def!: DropdownField;

  @Prop()
  private readonly errors!: FormSubmissionValidationError[];

  private value: string | null = null;

  get hasErrors(): boolean {
    return this.errors.length > 0;
  }

  getValue(): FormValue {
    return { Key: this.def.Key, Value: this.value };
  }

  setValue(val: FormValue): void {
    if (typeof val.Value === 'string' || val.Value === null) {
      this.value = val.Value as string | null;
    }
  }

  handleInput(): void {
    this.$emit('input', { def: this.def, value: this.getValue() });
  }
}
